import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';
import { desktop_breakpoint_extended } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

const PostCTAStyles = styled.div`
  margin-top: 20px;

  a:link,
  a:visited,
  a:hover,
  a:active {
    color: ${Colors.primary.black.standard};
    display: flex;
    flex-direction: row;
    text-decoration: none;

    .cta-image {
      border-radius: 4px;
      height: 95px;
      overflow: hidden;
      width: 95px;

      //fixes the blurry image effect caused by transform
      .aspect-image img {
        left: 0;
        top: 0;
        transform: none;
        -webkit-transform: none;
      }
    }

    .cta-content {
      display: flex;
      flex-direction: column;
      padding-left: 22px;
      width: calc(100% - 95px);

      .cta-headline {
        color: black;
      }

      .cta-subline {
        line-height: 1;
        margin-bottom: 5px;

        .label {
          /* used #71777E per UI designer instead of grey2 because Lighthouse had insufficient contrast issues. And we wanted to match the color used on post cards. */
          color: #71777e;
        }
      }
    }

    .standard {
      line-height: 1.4;
    }
  }

  &:last-child {
    margin-bottom: 40px;
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    a:link,
    a:visited,
    a:hover,
    a:active {
      flex-direction: column;

      .cta-image {
        height: 100%;
        width: 100%;
        height: 260px;
        max-height: 260px;
        max-width: 390px;

        .aspect-image img {
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          -webkit-transform: translate(-50%, -50%);
        }
      }

      .cta-content {
        height: 85px;
        overflow: hidden;
        padding-left: 0;
        text-overflow: ellipsis;
        width: 100%;

        .cta-subline {
          margin-top: 14px;
          margin-bottom: 7px;
        }

        .cta-headline {
          font-size: 18px;
        }
      }
    }

    margin: 0px;
  }
`;

export default PostCTAStyles;
